export const secrets = {
    recaptcha: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    googleCloud: 'AIzaSyA3MN_2tONNR4r24rmN-b6K1qL2KunFRPU'
};
